import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox, Loading  } from 'element-ui';
import store from '@/vuex/store'
import router from '@/router'
// import loadingPage from 'c/core/loading/http'
// let pageLoading = loadingPage()

const isProd = process.env.NODE_ENV === 'production'
let msgFlag = true
let loadFLag = true

class Http {
  constructor(baseurl = null) {
    // let baseURL = baseurl || (isProd ? '//mock.eolinker.com/vDc2CPQ1deab6900650911f571a627f30a465f17b410567?uri=/shop/' : '//mock.eolinker.com/vDc2CPQ1deab6900650911f571a627f30a465f17b410567?uri=/shop/')
    let proxy = 'http://118.31.61.135:8763' // proxyTable 8037 代理 http://q255e02653.zicp.vip:30087 http://118.31.61.135:8763
    let baseURL = baseurl || (!isProd ? proxy : 'http://118.31.61.135:8763')
    this._http = axios.create({
      baseURL,
      timeout: 8000,
    })

    this.uploadUrl = baseURL

    this.config = {
      // reqtime: +new Date
    }
  }

  upload(){
    return this.uploadUrl
  }

  create() {
    this._init()
    return this._http
  }

  _init() {
    this._http.interceptors.request.use(config => this._requestHandler(config, this.config), this._errorHandler) //发送请求
    this._http.interceptors.response.use(res => this._responseHandler(res), this._errorHandler) //处理请求
  }

  /**
   * [setRequestConfig 请求参数设置]
   * @param {Object} config [description]
   */
  setRequestConfig(config = {}) {
    this.config = Object.assign(this.config, config)
    return this
  }

  _requestHandler (config, _conf) {
    if(loadFLag){
      loadFLag = false;
      Loading.service({ fullscreen: true, background:'rgba(0,0,0,0)'}).close()
    }

    if(config.method === 'post') {
      config.headers = { 'Content-Type': 'application/json;charse=UTF-8', 'userId' : store.state.userInfo.redisKey ? store.state.userInfo.redisKey : ''}
      config.transformRequest = [ d => JSON.stringify(d) ]
    }

    if(config.method === 'put') {
      config.headers = { 'Content-Type': 'application/json' }
    }
    config.params = Object.assign(config.params || {}, _conf)
    return config
  }

  _responseHandler(res) {
    loadFLag = true;
    if(res.data.code == 2002 && msgFlag){
      msgFlag = false;
      MessageBox.alert(res.data.message, '提示', {
        confirmButtonText: '确定',
        callback: () => {
          router.push("/login/");
        }
      })
    }
    return res.data
  }

  _errorHandler(error) {
    Loading.service({ fullscreen: true, background:'rgba(0,0,0,0)'}).close()
    Message({
      message: '网络连接失败，请稍后再试',
      type: 'error'
    })
    // throw new Error(error)
    return Promise.reject(error)
  }
}

export default Http



// WEBPACK FOOTER //
// ./src/api/http.js